import { Fragment } from "react";
import { Tooltip } from "../../../../components";
import Link from "next/link";
import { StyledBlueSpan } from "./Success.styles";

const ListContent = {
  Line1: (
    <Fragment>
      You can now find and
      <Tooltip tooltipName="manageBooking">
        <StyledBlueSpan> update </StyledBlueSpan>
      </Tooltip>
      this ticket request in your profile under
      <Link href="/profile?tab=tickets">
        <StyledBlueSpan> Applications & Tickets </StyledBlueSpan>.
      </Link>
    </Fragment>
  ),
  Line2: (
    <Fragment>
      Ticket offers are usually sent out
      <Tooltip tooltipName="lastMinuteTickets">
        <StyledBlueSpan> 1 to 2 weeks </StyledBlueSpan>
      </Tooltip> 
      before the show date.
    </Fragment>
  ),
  Line3: (
    <Fragment>
      You and your guests will have a 
      <Tooltip tooltipName="ticketOfferExpiration">
        <StyledBlueSpan> limited time </StyledBlueSpan>
      </Tooltip> 
      to accept.
    </Fragment>
  ),
};

export const ListArray: React.ReactElement[] = [
  ListContent.Line1,
  ListContent.Line2,
  ListContent.Line3,
];

/**
 * The last min list (TTT-688 §5): applications made after the last-min phase opens join a
 * queue that is served by SMS at short notice, so "offers go out 1 to 2 weeks before the
 * show" above is not just unhelpful here, it is wrong.
 */
export const LastMinListArray: React.ReactElement[] = [
  ListContent.Line1,
  (
    <Fragment key="last-min-timing">
      Offers for this session go out
      <StyledBlueSpan> at short notice </StyledBlueSpan>
      - often on the day of the show, as seats are released.
    </Fragment>
  ),
  (
    <Fragment key="last-min-sms">
      We will
      <StyledBlueSpan> text you </StyledBlueSpan>
      when a seat opens up, so keep your phone handy - you will only have a short time to
      confirm before it goes to the next person.
    </Fragment>
  ),
];
